import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRevenueRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.745 2.537a.645.645 0 0 0-.005.912l3.986 4.04a.646.646 0 0 1 0 .905L9.519 12.65a.645.645 0 0 0 .917.906l4.206-4.252a1.936 1.936 0 0 0 0-2.72l-3.983-4.04a.645.645 0 0 0-.911-.006zM2.028 4.072c0-.236.194-.43.43-.43h3.589c.113 0 .223.046.303.126l3.87 3.87a.43.43 0 0 1 0 .608l-3.587 3.589a.43.43 0 0 1-.608 0l-3.87-3.87a.43.43 0 0 1-.127-.305zm-1.29 0V7.66c0 .457.18.895.503 1.218l3.87 3.87a1.72 1.72 0 0 0 2.433 0l3.588-3.588a1.72 1.72 0 0 0 0-2.432l-3.87-3.87a1.72 1.72 0 0 0-1.218-.503l-3.586-.003c-.948 0-1.72.771-1.72 1.72m3.01 2.15a.86.86 0 1 0 0-1.72.86.86 0 0 0 0 1.72",
		fill: "currentColor"
	})
});
export default SvgRevenueRegularIcon;
